import { render, staticRenderFns } from "./UiKeyVal.vue?vue&type=template&id=33b71d60&scoped=true&lang=pug&"
import script from "./UiKeyVal.vue?vue&type=script&lang=js&"
export * from "./UiKeyVal.vue?vue&type=script&lang=js&"
import style0 from "./UiKeyVal.vue?vue&type=style&index=0&id=33b71d60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b71d60",
  null
  
)

export default component.exports